module.exports = __webpack_public_path__ + "static/media/40.111c52ad.png";